import { useState } from 'react';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9k3750hpes2mi34sfmg';

export default function ContactSection() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);

    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      form.reset();
      setTimeout(() => setStatus('idle'), 3000);
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const res = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && (parsed as { code?: string })?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const msg = ((parsed as { meta?: { message?: string } })?.meta?.message)
          || ((parsed as { message?: string })?.message)
          || responseText
          || '提交失败，请稍后重试';
        if ((msg as string).toLowerCase().includes('spam')) {
          setStatus('error');
          setErrorMsg('提交失败，请稍后重试');
        } else {
          setStatus('error');
          setErrorMsg(msg as string);
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查网络连接后重试');
    } finally {
      if (status === 'loading') {
        setTimeout(() => {
          if (status !== 'success') setStatus('idle');
        }, 8000);
      }
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">联系我们</h2>
          <p className="mt-3 text-sm text-foreground-600">投稿建议 · 合作咨询 · 问题反馈</p>
        </div>

        <div className="max-w-lg mx-auto">
          <form data-readdy-form onSubmit={handleSubmit} className="bg-background-50 rounded-lg p-6 md:p-8 flex flex-col gap-4">
            <div>
              <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">姓名</label>
              <input
                id="contact-name"
                name="name"
                type="text"
                required
                className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                placeholder="请输入你的昵称"
              />
            </div>

            <div>
              <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">邮箱</label>
              <input
                id="contact-email"
                name="email"
                type="email"
                required
                className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                placeholder="请输入你的邮箱地址"
              />
            </div>

            <div>
              <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">留言内容</label>
              <textarea
                id="contact-message"
                name="message"
                required
                maxLength={500}
                rows={4}
                className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                placeholder="请输入你想说的话，最多500字"
              ></textarea>
            </div>

            <div className="form-honeypot">
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>

            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full py-3 rounded-md bg-primary-500 text-white text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors disabled:opacity-60"
            >
              {status === 'loading' ? '提交中...' : '发送留言'}
            </button>

            {status === 'success' && (
              <p className="text-sm text-center text-secondary-600">留言已成功发送，感谢你的反馈！</p>
            )}
            {status === 'error' && errorMsg && (
              <p className="text-sm text-center text-primary-600">{errorMsg}</p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}